import React from "react";
import Loading from "../../components/shared/loading/Loading";
import useFetch from "../../hooks/useFetch";
import useSession from "../../hooks/useSession";
import { apiPath } from "../../utility/Constant";
import BlogCard from "./BlogCard";
import { useState } from "react";
import { useEffect } from "react";

const BlogListPage = () => {
  const { blogListApi } = apiPath;
  const [user, loading] = useSession();
  const [blogList, blogListLoading] = useFetch(blogListApi, true);
  const [filteredData, setFilteredData] = useState([]);

  // sort by date
  useEffect(() => {
    //console.log(blogList);
    const data = [...blogList]?.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    setFilteredData(data);
  }, [blogList]);

  if (blogListLoading || loading) {
    return <Loading />;
  }

  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <BlogCard />
        {filteredData?.map((blog, index) => (
          <BlogCard key={index} blog={blog} user={user.role} />
        ))}
      </div>
    </div>
  );
};

export default BlogListPage;
